export var isTransient = function isTransient(error) {
  if (error.message && error.message.indexOf('status code 403')) {
    return false;
  }
  return !error.response || error.response.status < 400 || error.response.status >= 500;
};